<template>
  <div id="account-details" class="account-details" :model="dataForm">
    <div class="account-name">
      <div>{{ dataForm.customerName.substring(0, 1) }}</div>
      <p>{{ dataForm.customerName }}</p>
    </div>
    <div class="basic-data one">
      <div class="basic-left">
        <div class="basic-info">
          <div class="basic-title">姓名</div>
          <div class="basic-content">{{ dataForm.userName }}</div>
        </div>
        <div class="basic-info">
          <div class="basic-title">公司名称</div>
          <div class="basic-content">{{ dataForm.customerName }}</div>
        </div>
        <div class="basic-info">
          <div class="basic-title">联系电话</div>
          <div v-if="dataForm.mobilePhone != null" class="basic-content">
            {{ dataForm.mobilePhone }}
          </div>
        </div>
      </div>
      <div class="basic-right">
        <button
          class="by-common--primary"
          @click="
            () => {
              isDetailEdit = true;
            }
          "
        >
          修改
        </button>
      </div>
    </div>
    <div class="basic-data two">
      <div class="basic-left">
        <div class="basic-info">
          <div class="basic-title">邮箱</div>
          <div class="basic-content">{{ dataForm.email }}</div>
        </div>
      </div>
      <div class="basic-right">
        <button
          class="by-common--primary"
          @click="
            () => {
              isChangeEmail = true;
            }
          "
        >
          修改
        </button>
      </div>
    </div>
    <div class="basic-data two">
      <div class="basic-left">
        <div class="basic-info">
          <div class="basic-title">Password</div>
          <div class="basic-content">******</div>
        </div>
      </div>
      <div class="basic-right">
        <button
          class="by-common--primary"
          @click="
            () => {
              isChangePassword = true;
            }
          "
        >
          修改
        </button>
      </div>
    </div>
    <DetailEdit
      v-if="isDetailEdit"
      ref="DetailEdit"
      :is-show="isDetailEdit"
      @close="
        () => {
          isDetailEdit = false;
        }
      "
      @refresh="refresh"
    />
    <ChangeEmail
      v-if="isChangeEmail"
      ref="ChangeEmail"
      :is-show="isChangeEmail"
      @close="
        () => {
          isChangeEmail = false;
        }
      "
      @refresh="refresh"
    />
    <ChangePassword
      v-if="isChangePassword"
      ref="ChangePassword"
      :is-show="isChangePassword"
      @close="
        () => {
          isChangePassword = false;
        }
      "
      @refresh="refresh"
    />
  </div>
</template>

<script>
import { GetCurrCustomer } from '@/api/user'
import DetailEdit from './detailEdit.vue'
import ChangeEmail from './changeEmail.vue'
import ChangePassword from './changePassword.vue'
import request from '@/utils/request'
import { getCookie } from '@/utils/cookiejs'
export default {
  name: 'Index',
  components: {
    // 组件的引用
    DetailEdit,
    ChangeEmail,
    ChangePassword
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      dataForm: {
        realName: '',
        customerName: '',
        mobilePhone: '',
        email: ''
      },
      isDetailEdit: false,
      isChangeEmail: false,
      isChangePassword: false,
      token: ''
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
    this.token = getCookie('token')
    if (this.token) {
      this.getCustomerInfo()
    }
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
    getCustomerInfo() {
      GetCurrCustomer().then(res => {
        if (res.code === 200) {
          this.dataForm = res.data
        }
      })
    },
    refresh(isrRefresh) {
      // this.isEditDialog = false
      if (isrRefresh) this.getCustomerInfo()
    }
  }
}
</script>
<style scoped lang="scss">
.account-details {
  .account-name {
    width: 100%;
    height: 154px;
    background: #ffffff;
    border-radius: 8px;
    text-align: center;
    padding-top: 30px;
    div {
      width: 88px;
      height: 88px;
      background: #ed7738;
      border-radius: 55px;
      border: 3px solid rgba(233, 85, 6, 0);
      font-size: 50px;
      font-family: D-DINExp, D-DINExp;
      font-weight: bold;
      color: #ffffff;
      margin: 0 auto;
      line-height: 88px;
    }
    p {
      font-size: 18px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #333333;
      margin-top: 19px;
    }
  }
  .one {
    height: 136px;
  }
  .two {
    height: 40px;
  }
  .basic-data {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    background: #ffffff;
    border-radius: 8px;
    margin: 16px 0;
    padding: 16px 0;
    .basic-left {
      .basic-info {
        display: flex;
        .basic-title {
          margin-left: 24px;
          text-align: left;
          width: 154px;
          height: 44px;
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 40px;
        }
        .basic-content {
          height: 44px;
          line-height: 40px;
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #333333;
          margin-left: 24px;
        }
      }
    }
    .basic-right {
      margin-right: 24px;

      button {
        outline: none;
        border: none;
        width: 72px;
        height: 32px;
        background: transparent;
        border-radius: 8px;
        transition: all 0.3s;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #3370ff;
        line-height: 22px;
        text-align: center;
        font-style: normal;

        &:hover {
          cursor: pointer;
          background: rgba(51, 112, 255, 0.08);
        }
      }
    }
  }
}
</style>
